import * as React from 'react';
import { WithSearch } from "@elastic/react-search-ui";

export default function GroupLabel({ currentGroup }) {
  const separator = ' | ';

  let allowedAttributes = [];
  if (currentGroup && currentGroup.labelFields) {
    allowedAttributes = currentGroup.labelFields.split(',').map(item => item.trim()).filter(item => item.length > 0);
  }

  if (allowedAttributes.length < 1) {
    return null;
  }

  return (
    <WithSearch mapContextToProps={({ filters }) => ({ filters })}>
      {({ filters }) => {
        // Every selected value, not just the last one: a dropdown carries one
        // value, but a checkbox facet carries as many as the reader ticked, and
        // naming only the newest made each tick look like it had replaced the
        // previous selection. Values of one field are joined with a comma;
        // `separator` stays between fields.
        const parts = allowedAttributes.reduce((acc, attr) => {
          const filter = filters.find(f => f.field === attr);
          const values = (filter?.values || []).filter(value => value != null && value !== '');
          if (values.length > 0) acc.push(values.join(', '));
          return acc;
        }, []);

        if (parts.length === 0) {
          return null;
        }

        return (
          <div>
            {parts.join(separator)}
          </div>
        );
      }}
    </WithSearch>
  );
}
